/* hs-eslint ignored failing-rules */
/* eslint-disable promise/catch-or-return */

import quickFetch from 'quick-fetch';
export function wasJustFetched(prevProp, nextProp) {
  return prevProp.isRequesting && !nextProp.isRequesting && !nextProp.error || !prevProp.lastLoaded && nextProp.lastLoaded && !nextProp.error;
}
export function isFetched({
  isRequesting,
  lastLoaded
}) {
  return !isRequesting && lastLoaded !== undefined && lastLoaded !== null;
}
export function isError({
  error,
  isRequesting
}) {
  return !isRequesting && error !== undefined;
}
export function makeSimpleQuickFetchWrapper(getRequestName, makeRequest) {
  return (...args) => {
    const requestName = typeof getRequestName === 'function' ? getRequestName(...args) : getRequestName;
    const earlyRequest = quickFetch.getRequestStateByName(requestName);
    let resultPromise;
    if (earlyRequest) {
      resultPromise = new Promise((resolve, reject) => {
        earlyRequest.whenFinished(result => {
          resolve(result);
          quickFetch.removeEarlyRequest(requestName);
        });
        earlyRequest.onError(() => {
          makeRequest(...args).then(resolve, reject);
          quickFetch.removeEarlyRequest(requestName);
        });
      });
    } else {
      resultPromise = makeRequest(...args);
    }
    return resultPromise;
  };
}